import { Drawer } from 'antd';
import { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { VisibleDelayedInner } from '../../../shared-functions';

export default function DrawerDelayedToShowEmail(props: {
  drawer_visible: 1 | undefined;
  set_drawer_visible: React.Dispatch<React.SetStateAction<1 | undefined>>;
  title: string;
  height: number;
  message: string;
}) {
  const { set_drawer_visible } = useMemo(() => props, [props]);
  const handle_info_close = useCallback(() => {
    set_drawer_visible(undefined);
  }, [set_drawer_visible]);

  return (
    <Drawer
      title={<FormattedMessage id={props.title} />}
      placement='bottom'
      onClose={handle_info_close}
      visible={!!VisibleDelayedInner(props.drawer_visible)}
      height={props.height}
      headerStyle={{ textAlign: 'center' }}
      mask={false}
    >
      <p className='retrieve-info-content'>
        <FormattedMessage id={props.message}></FormattedMessage>
      </p>
    </Drawer>
  );
}
